/**
 * Upgrade HTML 5 video tags
 * Argent uses <video> to display quiet looping videos. Like GIFs, but better.
 */
export function initVideoGif() {
	const $videogif = $('.videogif').once('initVideoGif')

	let deps = Promise.reject()
	if ($videogif.length) {
		deps = Promise.all([
			import('onscreen'),
			import('../getScrollParent'),
			import('../onTapped')
		])
	}

	deps.then(([OnScreen, {getScrollParent}, {onTapped}]) => {
		$videogif.each(function () {
			const $this = $(this)
			const os = new OnScreen({
				container: getScrollParent(this)
			})

			os.on('enter', '.videogif', function (el) {
				el.play()
			})

			os.on('leave', '.videogif', function (el) {
				el.pause()
			})

			$this.data('os', os)

			// This is provided as a fallback; if the video does not autoplay then
			// at least a user can tap it to start.
			onTapped(this, this.play.bind(this))
		})
	}).catch(() => {})
}